'use client';

import GlobalError from '@repo/ui/system-pages/global-error';

export default GlobalError;
